import clsx from "clsx";
import type { ReactNode } from "react";

/** SP (<lg) のみで使う pane 最上部のヘッダー。 PC は AreaSidebar が同等情報を担う。 */
type DxPageHeaderProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  as?: "h1" | "h2";
  className?: string;
};

export function DxPageHeader({
  title,
  subtitle,
  actions,
  as = "h1",
  className,
}: DxPageHeaderProps) {
  const Heading = as;
  return (
    <header
      className={clsx(
        "flex items-start gap-[8px] px-[16px] pb-[8px]",
        className,
      )}
    >
      <div className="flex min-w-0 flex-1 flex-col pt-[6px]">
        <Heading className="dx-headline-1 text-dx-text-default">
          {title}
        </Heading>
        {subtitle !== undefined && (
          /* header の pb-8 と合算で subtitle 下 16px (Figma 1024-22098 仕様)。
           * subtitle 無しの時は header の 8px のみで Figma 通り。 */
          <p className="dx-body-3 text-dx-text-sub pb-[8px]">{subtitle}</p>
        )}
      </div>
      {actions !== undefined && (
        <div className="flex flex-none items-center">{actions}</div>
      )}
    </header>
  );
}
